export const getUserTierFromPlan = (plan: number): string => {
    const planMapping = {
        0: "guest",
        2: "premium",
        3: "free",
        4: "churned",
      };
    return planMapping[plan];
}